var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.main_layer)?_c('div',{staticClass:"div0"},[_c('Map2',{attrs:{"id":"subarea_m1","type":"large","selector":"true","lng":_vm.lng,"zoom":_vm.zoom,"lat":_vm.lat,"start":_vm.start,"end":_vm.end,"main_layer":_vm.main_layer}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }